import styled from "styled-components";

const StackListItem = styled.li<{isActive?: boolean}>`
	position: relative;
	padding: 0 20px;
	color: var(--gray-color);
	line-height: 1;

	${props =>
		props.isActive &&
		`
		color: var(--emp-color);
	`}

	&::after {
		position: absolute;
		top: 50%;
		left: 0;
		width: 1px;
		height: 12px;
		background-color: var(--line-color);
		transform: translateY(-50%);
		content: "";
	}

	&:first-child {
		&:after {
			display: none;
		}
	}

	&:last-child {
		padding-right: 0;
	}
`;

export default StackListItem;
